import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';

enum Repository {
    MOBILE = 'mobile',
    PLATFORM = 'platform',
    KIOSK = 'kiosk',
    TERMINAL_S4M = 'terminal-s4m'
}

export const RepositorySelect = (props: Omit<SelectInputV2Props<Repository>, 'options'>) => {
    const options = Object.values(Repository).map((repo) => ({
        label: repo.charAt(0).toUpperCase() + repo.slice(1).replace(/-/g, ' '),
        value: repo
    }));

    return (
        <SelectInputV2<Repository>
            {...props}
            options={options}
        />
    );
};
